import { WSElementColorsType } from "@wingspanhq/fe-component-library";

import { PayrollRunStatus } from "../types";

const PAYROLL_RUN_STATUS_COLOR: Record<PayrollRunStatus, WSElementColorsType> =
  {
    pending: "amber400",
    opened: "blue500",
    processing: "amber400",
    completed: "green400",
    failed: "red400"
  };

export const selectorPayrollRunStatusColor = (
  status: PayrollRunStatus
): WSElementColorsType => PAYROLL_RUN_STATUS_COLOR[status];
